import React from "react";
import { withStyles } from "@mui/styles";
import { TextField, Autocomplete, Box, MenuItem, Button } from "@mui/material";

import Label from "../label/Label";
import DialogModal from "../dialogModal/DialogModal";
import SingleLineTextInput from "../singleLineTextInput/SingleLineTextInput";

const styles = () => ({
  formControl: {
    width: "100%",
    marginBottom: 10,
  },
});

function DropdownSelect({
  classes,
  label,
  value,
  onSelect,
  items = [],
  placeholder,
  required,
  allowCustomInput = false,
  onSubmitNew,
}) {
  const [showAddNewOption, setShowAddNewOption] = React.useState(false);
  const [newOption, setNewOption] = React.useState("");

  const handleSelect = (event, option) => {
    if (!option) return;

    if (option.addNew) {
      setShowAddNewOption(true);
      return;
    }

    onSelect(option.value);
  };

  const handleSubmitNew = () => {
    if (!newOption.trim()) return;
    onSubmitNew?.(newOption.trim());
    setNewOption("");
    setShowAddNewOption(false);
  };

  const mappedItems = items.map((i) => ({
    label: i.label,
    value: i.value,
  }));

  const selectedItem = mappedItems.find((i) => i.value === value) || null;

  return (
    <Box className={classes.formControl}>
      {label && <Label title={label} required={required} />}

      {items.length === 0 && allowCustomInput ? (
        <Button
          variant="outlined"
          onClick={() => setShowAddNewOption(true)}
          fullWidth
        >
          Add new option
        </Button>
      ) : (
        <Autocomplete
          options={mappedItems}
          getOptionLabel={(option) => option.label || ""}
          value={selectedItem}
          onChange={handleSelect}
          filterOptions={(options, { inputValue }) => {
            const filtered = options.filter((option) =>
              option.label.toLowerCase().includes(inputValue.toLowerCase())
            );

            if (allowCustomInput) {
              filtered.push({
                label: "➕ Add new",
                addNew: true,
              });
            }

            return filtered;
          }}
          renderOption={(props, option) => (
            <MenuItem {...props} key={option.value || option.label}>
              {option.label}
            </MenuItem>
          )}
          renderInput={(params) => (
            <TextField {...params} placeholder={placeholder} />
          )}
          fullWidth
        />
      )}

      {showAddNewOption && (
        <DialogModal
          title="Add new option"
          onClose={() => setShowAddNewOption(false)}
          cancelText="Close"
          onSubmit={() => handleSubmitNew()}
          submitText="Save"
        >
          <SingleLineTextInput
            placeholder="New option"
            value={newOption}
            onChange={(value) => setNewOption(value)}
          />
        </DialogModal>
      )}
    </Box>
  );
}

export default withStyles(styles)(DropdownSelect);
